import PropTypes from 'prop-types'
import { getNormalizedTagColor } from 'utils/TagAppearanceHelper'
/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.



import 'styles/components/TagColorSelector.styl'


const SUBMIT_IMAGES_BY_COLOR = [
  'FF876B',
  '13CB6E',
  '00E0FF',
  '2D8EFF',
  'EA81FF',
  '7695A5',
  'E95330',
  '1F9A57',
  '009AB0',
  '0960C5',
  'A60087',
  '394F5A',
]

const TagColorSelector = React.createClass({

  propTypes: {
    colorClicked: PropTypes.func.isRequired
  },

  onColorClick(tagColor) {
    return this.props.colorClicked(tagColor)
  },

  render() {
    return (
      <div className="TagColorSelector">
        <div className="tag-colors">
          {_.map(SUBMIT_IMAGES_BY_COLOR, tagColor => {
            return (
              <div
                key={tagColor}
                onClick={this.onColorClick.bind(this, tagColor)}
                className="tag-color"
                style={{
                  backgroundColor: `#${getNormalizedTagColor(tagColor)}`,
                  color: 'var(--main-navy-extra-dark)',
                }} />
            )
          })}
        </div>
      </div>
    )
  }
})

export default TagColorSelector



// WEBPACK FOOTER //
// ./src/scripts/components/TagColorSelector.js